export const API_CONSTANTS = {
  contentType: 'Content-Type',
};
